import * as autobind from 'autobind';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { RequestReasonDto, RequestReasonStore } from '../../stores/configuration/events-n-requests/request-reasons-store';
import { nameof } from '../../utils/object';
import { ItemReference, QueryResult } from '../../stores/dataStore';
import { isNullOrWhiteSpaces } from '../../utils/useful-functions';
import { SelectionInput } from '../../widgets/form/selectionInput';

interface RequestReasonEditorProps extends WithTranslation {
  value: ItemReference;
  onChange?: (value: ItemReference) => void;
  onSelected?: (requestReason: RequestReasonDto) => void;
  requestReasons?: RequestReasonStore;
  nullable?: boolean;
  minWidth?: number;
  reloadOnChange?: boolean;
  className?: string;
  placeholder?: string;
  clearable?: boolean;
  readOnly?: boolean;
  filterEventTypeId?: string;
}

interface RequestReasonEditorState {
  query?: (searchQuery: string) => Promise<QueryResult<ItemReference>>;
}

@connect(['requestReasons', RequestReasonStore])
class RequestReasonEditor extends React.Component<RequestReasonEditorProps, RequestReasonEditorState> {
  private get requestReasonsStore() {
    return this.props.requestReasons;
  }

  constructor(props: RequestReasonEditorProps) {
    super(props);

    this.state = {
      query: this.getRequestReasons()
    };
  }

  @autobind
  private getRequestReasons() {
    const method = async (search: string) => {
      const filter = [];
      if (!isNullOrWhiteSpaces(search)) {
        filter.push(`startswith(tolower(${nameof<RequestReasonDto>('name')}), '${search.toLowerCase()}')`);
      }

      if (this.props.filterEventTypeId) {
        filter.push(`EventTypesIds ne null and EventTypesIds/IdWords/any(id:(id eq ${this.props.filterEventTypeId}))`);
      }

      const result = await this.requestReasonsStore.getAllAsync({
        searchQuery: '',
        skip: 0,
        take: 100000,
        orderBy: [{ direction: 'Ascending', field: nameof<RequestReasonDto>('name'), useProfile: false }],
        filter
      });

      return Object.assign({}, result, { items: result.items.map(c => ({ id: c.id, title: c.name })) }) as QueryResult<ItemReference>;
    };
    return method;
  }

  @autobind
  private onChange(value: ItemReference) {
    if (this.props.onChange) this.props.onChange(value);
    if (this.props.onSelected) {
      if (value) {
        let requestReasonSelected = this.requestReasonsStore.state.items.first(item => item.item.id === value.id).item;
        this.props.onSelected(requestReasonSelected);
      } else {
        this.props.onSelected(null);
      }
    }
  }

  public render() {
    const query = this.state.query;
    return (
      <SelectionInput
        content={item => <div>{item.title}</div>}
        searchable
        readOnly={this.props.readOnly}
        className={this.props.className}
        minWidth={this.props.minWidth}
        nullable={this.props.nullable}
        placeholder={this.props.placeholder}
        query={query}
        value={this.props.value}
        onChange={this.onChange}
        clearable={this.props.clearable}
      />
    );
  }
}

// Wire up the React component to the Redux store
export default withTranslation()(RequestReasonEditor);
